<template>
    <div>
        <p class="vehicle-page-flow__headline">{{ dictionary.vehicleFlowCommonPersonalDetailsHeadline }}</p>
        <p class="vehicle-page-flow__text" v-html="dictionary.vehicleFlowCommonPersonalDetailsText"></p>
        <p v-if="!showLogin" class="vehicle-page-flow__text"><a @click="showLogin = true">Klik her for at logge ind.</a>
        </p>
        <p v-if="showLogin" class="vehicle-page-flow__text"><a @click="showLogin = false">Tilbage til formular.</a></p>
        <br />
        <LoginMemberForm v-if="showLogin" @loggedIn="handleMemberLogin" />
        <div v-if="!showLogin">
            <div class="formgrid grid">
                <div class="field col-12 sm:col-6">
                    <label for="firstName">Fornavn * <span v-if="v$.personalInformation.firstName.$invalid"
                            class="p-invalid">Mangler</span></label>
                    <InputText id="firstName" type="text" v-model="v$.personalInformation.firstName.$model"
                        @blur="v$.personalInformation.firstName.$touch"
                        :class="{ 'p-invalid': v$.personalInformation.firstName.$invalid }" />
                </div>
                <div class="field col-12 sm:col-6">
                    <label for="lastName">Efternavn * <span v-if="v$.personalInformation.lastName.$invalid"
                            class="p-invalid">Mangler</span></label>
                    <InputText id="lastName" type="text" v-model="v$.personalInformation.lastName.$model"
                        @blur="v$.personalInformation.lastName.$touch"
                        :class="{ 'p-invalid': v$.personalInformation.lastName.$invalid }" />
                </div>
                <div class="field col-12 sm:col-6">
                    <label for="email">Email * <span v-if="v$.personalInformation.email.$invalid"
                            class="p-invalid">Mangler</span></label>
                    <InputText id="email" type="text" v-model="v$.personalInformation.email.$model"
                        @blur="v$.personalInformation.email.$touch"
                        :class="{ 'p-invalid': v$.personalInformation.email.$invalid }" />
                </div>
                <div class="field col-12 sm:col-6">
                    <label for="phone">Telefon * <span v-if="v$.personalInformation.phone.$invalid"
                            class="p-invalid">Mangler</span></label>
                    <InputMask id="phone" mask="99999999" v-model="v$.personalInformation.phone.$model"
                        @blur="v$.personalInformation.phone.$touch"
                        :class="{ 'p-invalid': v$.personalInformation.phone.$invalid }" placeholder="XXXXXXXX" />
                </div>
                <div class="field col-12 sm:col-6">
                    <label for="address">Vejnavn</label>
                    <InputText id="address" type="text" v-model="personalInformation.address" />
                </div>
                <div class="field col-12 sm:col-6">
                    <label for="country">Land</label>
                    <InputText id="country" type="text" v-model="personalInformation.country" />
                </div>
                <div class="field col-12 sm:col-6">
                    <label for="city">By</label>
                    <InputText id="city" type="text" v-model="personalInformation.city" />
                </div>
                <div class="field col-12 sm:col-6">
                    <label for="zipCode">Postnummer</label>
                    <InputText id="zipCode" type="text" v-model="personalInformation.zipCode" />
                </div>
                <div class="field col-12 sm:col-6">
                    <small>{{ dictionary.vehicleFlowCommonRequiredFields }}</small>
                </div>
            </div>
            <slot></slot>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import LoginMemberForm from './loginMemberForm.vue';

import { useVuelidate } from '@vuelidate/core'
import { required, email, integer, minLength, maxLength } from '@vuelidate/validators'
var watchTimer;

export default {
    name: "personalInformationForm",
    props: ["userModel", "dictionary"],
    components: {
        Button,
        InputText,
        InputMask,
        LoginMemberForm
    },
    data() {
        return {
            showLogin: false,
            personalInformation: {
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                address: null,
                country: null,
                city: null,
                zipCode: null
            },
        };
    },
    setup() {
        return { v$: useVuelidate() }
    },
    created() {
        const vm = this;

        if (vm.userModel) {
            if(vm.userModel.firstName != vm.personalInformation.firstName){
                vm.personalInformation.firstName = vm.userModel.firstName;
            }
            if(vm.userModel.lastName != vm.personalInformation.lastName){
                vm.personalInformation.lastName = vm.userModel.lastName;
            }
            if(vm.userModel.email != vm.personalInformation.email){
                vm.personalInformation.email = vm.userModel.email;
            }
            if(vm.userModel.phone != vm.personalInformation.phone){
                vm.personalInformation.phone = vm.userModel.phone;
            }
            if(vm.userModel.address != vm.personalInformation.address){
                vm.personalInformation.address = vm.userModel.address;
            }
            if(vm.userModel.country != vm.personalInformation.country){
                vm.personalInformation.country = vm.userModel.country;
            }
            if(vm.userModel.city != vm.personalInformation.city){
                vm.personalInformation.city = vm.userModel.city;
            }
            if(vm.userModel.zipCode != vm.personalInformation.zipCode){
                vm.personalInformation.zipCode = vm.userModel.zipCode;
            }
        }

        fetch('/umbraco/api/memberapi/GetLoggedInMember')
            .then(response => {
                if (response.status == 401) {
                    vm.member = null;
                    vm.memberArea = vm.memberAreas?.login;
                    const error = new Error("");
                    error.status = response.status;
                    throw error;
                }
                return response;
            })
            .then(response => response.json())
            .then(data => {
                if (data.id != 0) {
                    vm.handleMemberLogin(data);
                }
            })
            .catch(error => {
                if (error.status != 401) {
                    console.log(error);
                }
            });
    },
    watch: {
        personalInformation: {
            handler(newValue, oldValue) {
                clearTimeout(watchTimer);
                watchTimer = setTimeout(() => {
                    this.handlePersonalInformationChange(newValue, oldValue);
                }, 250);
            },
            deep: true
        }
    },
    validations() {
        return {
            personalInformation: {
                firstName: { required, $lazy: true },
                lastName: { required, $lazy: true },
                email: { required, email, $lazy: true },
                phone: {
                    required,
                    integer,
                    minLengthValue: minLength(8),
                    maxLengthValue: maxLength(8),
                    $lazy: true
                }
            }
        }
    },
    methods: {
        handleMemberLogin(member) {
            const vm = this;
            vm.personalInformation.firstName = member.firstName;
            vm.personalInformation.lastName = member.lastName;
            vm.personalInformation.email = member.email;
            vm.personalInformation.phone = member.phone;
            vm.personalInformation.address = member.address;
            vm.personalInformation.country = member.country;
            vm.personalInformation.city = member.city;
            vm.personalInformation.zipCode = member.zipCode;
            vm.showLogin = false;
        },
        async handlePersonalInformationChange(newValue, oldValue) {
            const isValid = await this.v$.$validate()
            this.$emit("personalInformationUpdated", { info: newValue, isValid: isValid });
        }
    }
};
</script>
